import { Component, Input, OnInit, ViewEncapsulation } from '@angular/core';
import { FormArray, FormBuilder, FormGroup, Validators } from '@angular/forms';
import { NgbActiveModal, NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { id } from '@swimlane/ngx-datatable';
import { BrandService } from 'app/services/models/brand.service';
import { CompanyService } from 'app/services/models/company.service';
import { DeviceService } from 'app/services/models/device.service';
import { KindService } from 'app/services/models/kind.service';
import { PersonService } from 'app/services/models/person.service';
import { Turkish } from 'flatpickr/dist/l10n/tr';
import { FlatpickrOptions } from 'ng2-flatpickr';
import { ToastrService } from 'ngx-toastr';
import { CreateBrandModelComponent } from '../create-brand-model/create-brand-model.component';
import { ReferenceService } from 'app/services/models/reference.service';
import { CreateDevice } from 'app/dtos/device/createDevice';
import { CreateKindDialogComponent } from '../create-kind-dialog/create-kind-dialog.component';
import { CreateBrandDialogComponent } from '../create-brand-dialog/create-brand-dialog.component';
import { ProductService } from 'app/services/models/product.service';
import { ReferenceTransactionsComponent } from '../reference-transactions/reference-transactions.component';

@Component({
  selector: 'app-create-device-dialog',
  templateUrl: './create-device-dialog.component.html',
  styleUrls: ['./create-device-dialog.component.scss'],
  encapsulation: ViewEncapsulation.None
})
export class CreateDeviceDialogComponent implements OnInit {
  @Input() data: { id: number; companyId: number; device?: any; isReferenceDevice: boolean; isButtonPrivate?: boolean; isGetAllProduct:boolean };
  checkboxValue: boolean = false
  public dateTimeStartOptions: FlatpickrOptions = {
    altInput: true,
    enableTime: true,
    dateFormat: 'd.m.Y H:i',
    altFormat: 'd.m.Y H:i',
    locale: Turkish,
  };


  deviceForm: FormGroup;
  brands: any[];
  kinds: any[];
  companies: any[];
  companyPersons: any[];
  references: any[];
  products: any[];

  constructor(
    private brandService: BrandService,
    private fb: FormBuilder,
    private kindSerivce: KindService,
    private companyService: CompanyService,
    public activeModal: NgbActiveModal,
    private deviceSerivce: DeviceService,
    private personSerivce: PersonService,
    private toastrService: ToastrService,
    private modalService: NgbModal,
    private referenceService: ReferenceService,
    private productService: ProductService
  ) {
    if (this.data && this.data.isButtonPrivate === undefined) {
      this.data.isButtonPrivate = false;
    }
    if(this.data && this.data.isGetAllProduct === undefined){
      this.data.isGetAllProduct = false;
    }
    this.deviceForm = this.fb.group({
      companyId: [null, Validators.required], // Tek firma seçimi
      companyPersonId: [null],
      transactionProductId: [null],
      createDevicesList: this.fb.array([this.createProductForm()]) // Birden fazla ürün formu
    });
  }

  createProductForm(): FormGroup {
    return this.fb.group({
      brandModelId: [null, Validators.required],
      brandId: [null],
      kindId: [null, Validators.required],
      seriNo: [null],
      inventoryNumber: [null],
      description: [null],
      code: [null],
      deviceName: ['', Validators.required],
      isDeviceStatus: [true],
      resolution: [null],
      referenceId: [null],
      period: [null],
      place: [null],
    });
  }

  get createDevicesList(): FormArray {
    return this.deviceForm.get('createDevicesList') as FormArray;
  }

  addProduct() {
    this.createDevicesList.push(this.createProductForm());
  }

  removeProduct(index: number) {
    this.createDevicesList.removeAt(index);
  }

  copyProduct() {
    const lastIndex = this.createDevicesList.length - 1;
    if (lastIndex >= 0) {
      const lastProduct = this.createDevicesList.at(lastIndex).value; // Son cihazı al
      console.log(lastProduct);
      const copiedProduct = { ...lastProduct, seriNo: '' }; // SeriNo boş bırakılır

      this.createDevicesList.push(this.fb.group(copiedProduct)); // Yeni cihazı ekle
    }
  }

  async ngOnInit() {
    this.deviceForm.markAllAsTouched();

    this.createDevicesList.controls.forEach(control => {
      control.markAllAsTouched();
    });

    this.checkboxValue = this.data.isReferenceDevice;
    await this.getAllBrand();
    await this.getAllKinds();
    await this.getAllCompaines();
    await this.getAllReferences();
    if (this.data.isGetAllProduct) {
      await this.getAllProducts();
    }
    console.log(this.data);

    if (this.data.companyId) {
      this.deviceForm.patchValue({
        companyId: Number(this.data.companyId)
      });
      await this.getAllCompanyPersons(this.data.companyId);
    }

    if (this.data?.device) {
      console.log(this.data.device);
      const device = this.data.device;
      this.createDevicesList.at(0).get('deviceName')?.setValue(device.name);
      this.createDevicesList.at(0).get('kindId')?.setValue(device.kindId);
    }

    this.brandService.event$.subscribe(async result => {
      await this.getAllBrand();
    });

    this.kindSerivce.event$.subscribe(async result => {
      await this.getAllKinds();
    })

    this.deviceForm.get('companyId').valueChanges.subscribe((companyId) => {
      if (companyId) {
        this.getAllCompanyPersons(companyId);
      }
    });

    this.deviceForm.get('transactionProductId').valueChanges.subscribe((transactionProductId) => {
      const product = this.products.find(p => p.id == transactionProductId);
      console.log(product);
      if (product) {
        // İlk cihaz formuna deviceName ve typeName verilerini yerleştir
        const firstDeviceForm = this.createDevicesList.at(0);
        this.autoDeviceName = product.name;
        firstDeviceForm.patchValue({
          deviceName: product.name,
          kindId: product.kindId // 'typeName' için description alanını kullandık
        });
      }
    })
  }

  autoDeviceName: string = ''; // component içinde
  preventDelete(event: KeyboardEvent) {
    const input = event.target as HTMLInputElement;
    console.log(input.selectionStart);
    const firstDeviceForm = this.createDevicesList.at(0);
    const productName = this.autoDeviceName;
  
    // Backspace ve Delete tuşlarını engelle, sadece otomatik ürün adını silemesin
    if ((event.key === 'Backspace' && input.selectionStart! <= productName.length) ||
        (event.key === 'Delete' && input.selectionStart! < productName.length)) {
      event.preventDefault();
    }
  }

  async getAllProducts() {
    const data = await this.productService.getAllProducts(0, 1000, '', null, null, null, null, null, null, null);
    console.log(data);
    this.products = data.products;
  }

  async getAllReferences() {
    const data = await this.referenceService.getAllReference(0, 100);
    console.log(data);
    this.references = data.references;
  }

  searchFn(term: string, item: any) {
    term = term.toLowerCase();
    return item.name?.toLowerCase().includes(term) || item.brandName?.toLowerCase().includes(term);
  }


  async getAllKinds() {
    const data = await this.kindSerivce.getAllKinds('', 0, 100, 13);
    console.log(data);
    this.kinds = data.types;
  }

  async getAllCompaines() {
    const data = await this.companyService.getAllCompany('', 0, 1000);
    console.log(data);
    this.companies = data.companies;
  }

  async getAllCompanyPersons(companyId) {
    const data = await this.personSerivce.getAllCompaniesPersons(0, 1000, companyId);
    this.companyPersons = data.persons;
    console.log(data);
  }

  async getAllBrand() {
    const data = await this.brandService.getBrands();
    // flatMap kullanarak tek katmanlı bir dizi oluşturuyoruz
    this.brands = data;
    console.log(this.brands);
  }

  filteredModels: any[] = [];

  onBrandChange(brandId: number) {
    this.filteredModels = [];
    console.log(brandId);
    const brand = this.brands.find(p => p.id === brandId);
    this.filteredModels = brand.brandModels || [];
    const selectedModelId = this.deviceForm.get('brandModelId')?.value;
    const isValidModel = this.filteredModels.some(m => m.id === selectedModelId);

    if (!isValidModel) {
      this.deviceForm.get('brandModelId')?.setValue(null);
    }
  }

  async onSumbit() {
    const products = this.deviceForm.value.createDevicesList;
    console.log(products);
    // Seri numarası kontrolü
    const uniqueKeys = new Set(products.map(p => `${p.brandModelId}-${p.seriNo}`));

    if (uniqueKeys.size !== products.length) {
      this.toastrService.error('Aynı seri numarası ve marka/model kombinasyonuyla ürün ekleyemezsiniz.');
      return;
    }

    console.log(this.deviceForm.value);

    let formData: CreateDevice[] = [];
    for (const p of products) {
      const formattedData: CreateDevice = {
        brandModelId: p.brandModelId,
        kindId: p.kindId,
        seriNo: p.seriNo,
        code: p.code,
        deviceName: p.deviceName,
        isDeviceStatus: p.isDeviceStatus,
        description: p.description,
        companyId: this.deviceForm.value.companyId,
        companyPersonId: this.deviceForm.value.companyPersonId,
        createDeviceAdditionalInformation: {
          resolution: p.resolution,
          referenceId: p.referenceId,
          period: p.period,
          inventoryNumber: p.inventoryNumber,
          deviceId: 0, // Eğer deviceId backend tarafından atanan bir değer ise null geçilebilir
          place: p.place,
        }
      };

      formData.push(formattedData); // Listeye ekle
    }

    console.log(formData);

    // Formu backend'e gönder
    try {
      const response = await this.deviceSerivce.createDevice(formData);
      console.log(response)
      const mapping: Array<{ transactionProductId: number, newDeviceId: number }> = [];

      let newDeviceIds = [];
      response.forEach(element => {
        if (element.status == true) {
          this.deviceSerivce.sendEvent(true);
          this.toastrService.success(element.message);
          if (element.data) {
            mapping.push({ transactionProductId: this.deviceForm.value.transactionProductId, newDeviceId: element.data });
          }
        } else {
          if (element.data) {
            mapping.push({ transactionProductId: this.deviceForm.value.transactionProductId, newDeviceId: element.data });
          }
          this.toastrService.error(element.message);
        }
      });
      this.activeModal.close(mapping);
    } catch (error) {
      this.toastrService.error('Cihazlar eklenirken bir hata oluştu.');
    }
  }

  closeModal() {
    this.activeModal.close(false);
  }

  onCreateBrandModel(index: number) {
    const formArray = this.deviceForm.get('createDevicesList') as FormArray;
    const currentForm = formArray.at(index) as FormGroup;

    const brandId = currentForm.get('brandId')?.value;

    const modal = this.modalService.open(CreateBrandModelComponent);
    modal.componentInstance.brandId = Number(brandId);
    modal.result.then(async (result) => {
      if (result === true) {
        await this.getAllBrand();


        const updatedBrand = this.brands.find(b => b.id === brandId);
        this.onBrandChange(updatedBrand.id);
        const brandModels = updatedBrand?.brandModels || [];

        // filteredModels için özel bir array tutuyorsan burada güncellemen gerekebilir

        currentForm.patchValue({
          brandModelId: brandModels[brandModels.length - 1]?.id || null
        });
      }
    }).catch(() => { })
  }

  createBrand(index: number) {
    const modal = this.modalService.open(CreateBrandDialogComponent);
    modal.result.then(async (result) => {
      if (result === true) {
        await this.getAllBrand();
        const lastBrand = this.brands[this.brands.length - 1];
        const formArray = this.deviceForm.get('createDevicesList') as FormArray;
        const firstProductForm = formArray.at(index) as FormGroup;

        firstProductForm.patchValue({
          brandId: lastBrand.id
        });
        this.onBrandChange(lastBrand.id);
      }
    }).catch(() => {
      // ESC ile kapandıysa hata atma
    });
  }

  createKindModal() {
    const modal = this.modalService.open(CreateKindDialogComponent, {
      windowClass: 'modal modal-sucess'
    });
    modal.componentInstance.data = {
      title: "Cihaz Türü Ekle",
      typeNumber: 13
    };
  }

  showCreateReferenceDialog(){
    const modal = this.modalService.open(ReferenceTransactionsComponent,{
      size: 'sm',
      backdrop: 'static',
    });
    modal.result.then(async (result) => {
      console.log(result);
      if(result === true){
        await this.getAllReferences();
      }
    }).catch(() => { })
  }
}